export default "__VITE_ASSET__DxBg6MmI__"